var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3335 8.66671H4.52016L9.36016 2.85338C9.58648 2.58109 9.69536 2.23005 9.66286 1.87748C9.63035 1.52491 9.45912 1.19969 9.18683 0.973375C8.91454 0.747057 8.5635 0.638175 8.21093 0.670681C7.85836 0.703187 7.53315 0.87442 7.30683 1.14671L0.640163 9.14671C0.59531 9.21034 0.555202 9.27719 0.520163 9.34671C0.520163 9.41338 0.520163 9.45338 0.42683 9.52004C0.366394 9.67292 0.334751 9.83566 0.333496 10C0.334751 10.1644 0.366394 10.3272 0.42683 10.48C0.42683 10.5467 0.426829 10.5867 0.520163 10.6534C0.555202 10.7229 0.59531 10.7897 0.640163 10.8534L7.30683 18.8534C7.43219 19.0039 7.58918 19.1249 7.76662 19.2079C7.94407 19.2908 8.13761 19.3337 8.3335 19.3334C8.64503 19.334 8.94695 19.2255 9.18683 19.0267C9.32184 18.9148 9.43344 18.7773 9.51525 18.6222C9.59705 18.467 9.64744 18.2973 9.66354 18.1227C9.67965 17.948 9.66114 17.7719 9.60908 17.6045C9.55702 17.437 9.47243 17.2814 9.36016 17.1467L4.52016 11.3334H20.3335C20.6871 11.3334 21.0263 11.1929 21.2763 10.9429C21.5264 10.6928 21.6668 10.3537 21.6668 10C21.6668 9.64642 21.5264 9.30728 21.2763 9.05723C21.0263 8.80719 20.6871 8.66671 20.3335 8.66671Z",
    fill: "#A63494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.193f8e91d8cc79268b0175ebfee904f9.svg";
export { ForwardRef as ReactComponent };